import {BaseEndpoint} from "@/api/BaseEndpoint";

export default (new BaseEndpoint('programs'));
